<fieldset class="row gy-3 gx-4">
  <legend class="h6 text-dark mb-0">{{ mode() | titlecase }} cargo</legend>
  @for (goodsItem of goodsGroups?.controls; track goodsItem) {
    <app-form-field
        class="col-12 col-md-7 mt-md-3"
        [class]="{'mt-6': $index > 0}"
        label="Cargo type"
        [customLabelClass]="'pt-0 d-block' + ($index > 0 ? ' d-md-none' : '')"
        [includeMargin]="false">
      <app-search
          [formControl]="goodsItem.controls.cargoType"
          [options]="(goodsItem.controls.cargoType.value)
            ? $any([goodsItem.controls.cargoType.value, ...availableCargoTypes()]).sort((a, b) => a - b)
            : availableCargoTypes()"
          [inputFormatter]="formatCargoType"
          [seachFormattedOptions]="true"
          [required]="true"
          [placeholder]="'Type to search'">
        <div class="invalid-feedback">Cargo type is required</div>
      </app-search>
    </app-form-field>
    <div class="col-12 col-md-5 d-flex">
      <app-form-field
        class="tonnage-field"
        label="Tonnage"
        [customLabelClass]="'pt-0 d-block' + ($index > 0 ? ' d-md-none' : '')"
        [includeMargin]="false">
        <app-cargo-weight
          [formControl]="goodsItem.controls.weight"
          [wrapError]="false">
          <div class="invalid-feedback">Tonnage is required</div>
        </app-cargo-weight>
      </app-form-field>
      @if (goodsGroups?.length && goodsGroups.length > 1) {
        <div
          class="mt-5"
          [class]="{
              'mt-md-1': $index > 0
            }">
          <button
            type="button"
            class="btn btn-outline-danger btn-delete rounded-circle ms-4 p-1 h1 border-0 shadow-none"
            (click)="removeGoods($index)">
            <i class="fa fa-fw fa-light fa-trash-can"></i>
          </button>
        </div>
      }
    </div>
  }
  @if (goodsGroups?.controls?.length && goodsGroups.controls.length < cargoTypes().length) {
    <div class="col-12">
      <button type="button" class="btn btn-outline-primary" (click)="addGoods()">
        <i class="fa-solid fa-plus me-2"></i>
        <span>Add {{ mode() | lowercase }} cargo</span>
      </button>
    </div>
  }
</fieldset>
